import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { addOrientationChangeListenerInEffect } from '../util/addOrientationChangeListenerInEffect';

const getDimensions = (id, fullWidthContainerId) => {
   const el = document.getElementById(id);
   const fullWidthEl = document.getElementById(fullWidthContainerId);
   if (el != null) {
      return {
         width: Math.max(el.clientWidth, fullWidthEl.clientWidth),
         height: el.clientHeight,
      };
   }
   return { width: 0, height: 0 };
};

const useCanvasSize = (id, fullWidthContainerId) => {
   const [canvasDimensions, setCanvasDimensions] = useState(
      getDimensions(id, fullWidthContainerId)
   );

   const tutorialActive = useSelector(
      ({ tutorial, activeExercise }) => !!tutorial || !!activeExercise?.prompt
   );

   useEffect(() => {
      const newDimensions = getDimensions(id, fullWidthContainerId);

      setCanvasDimensions((prevDimensions) => {
         if (
            prevDimensions.width === newDimensions.width &&
            prevDimensions.height === newDimensions.height
         ) {
            return prevDimensions;
         }
         return newDimensions;
      });
   }, [tutorialActive, id, fullWidthContainerId]);

   useEffect(() => {
      const updateDimensions = () => {
         setCanvasDimensions(getDimensions(id, fullWidthContainerId));
      };
      return addOrientationChangeListenerInEffect(updateDimensions);
   }, [id, fullWidthContainerId]);

   return canvasDimensions;
};

export { useCanvasSize };
